import {Component} from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import * as moment from "moment";
import {Moment} from "moment";
import {TimezoneService} from "../../../../../services/timezone.service";

@Component({
  selector: 'app-kpi-recalculate-measures-dialog',
  templateUrl: './kpi-recalculate-measures-dialog.component.html',
  styleUrls: ['./kpi-recalculate-measures-dialog.component.scss']
})
export class KpiRecalculateMeasuresDialogComponent {

  timePeriod: string;
  kpiTimezone: string;

  currentDate: Date;
  startDate: Date;
  endDate: Date;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private timezoneService: TimezoneService
  ) {
    this.timePeriod = config.data.timePeriod;
    this.kpiTimezone = config.data.kpiTimezone;
    this.currentDate = new Date();
    this.buildInputDates();
  }

  public cancel(): void {
    this.ref.close();
  }

  public save(): void {
    this.ref.close([
      this.browserTimezoneDateToUserTimezoneTimestamp(this.startDate),
      this.browserTimezoneDateToUserTimezoneTimestamp(this.endDate),
    ]);
  }

  private buildInputDates(): void {
    let inputStartMoment: Moment = moment(new Date());
    let inputEndMoment: Moment = moment(new Date());

    if (this.timePeriod === 'HOURLY') {
      inputStartMoment = inputStartMoment.subtract(1, 'day').startOf('day');
      inputEndMoment = inputEndMoment.startOf('day');

    } else if (this.timePeriod === 'DAILY') {
      inputStartMoment = inputStartMoment.subtract(7, 'day').startOf('day');
      inputEndMoment = inputEndMoment.startOf('day');

    } else if (this.timePeriod === 'WEEKLY') {
      inputStartMoment = inputStartMoment.subtract(4, 'week').startOf('week');
      inputEndMoment = inputEndMoment.startOf('week');

    } else if (this.timePeriod === 'MONTHLY') {
      inputStartMoment = inputStartMoment.subtract(5, 'month').startOf('month');
      inputEndMoment = inputEndMoment.startOf('month');
    }

    this.startDate = inputStartMoment.toDate();
    this.endDate = inputEndMoment.toDate();
  }

  private browserTimezoneDateToUserTimezoneTimestamp(date: Date): number {
    const targetZone: string = this.timePeriod === 'HOURLY' ? this.timezoneService.getCurrentTimezone() : this.kpiTimezone;
    const dateWithoutZone: string = moment(date).format('YYYY-MM-DD HH:mm:ss');
    return moment.tz(dateWithoutZone, targetZone).valueOf();
  }

}
